import { BaseRequestModel } from '../base.requestModel';

export class ProductRequestModel extends BaseRequestModel {
    protected static modelRouteName = 'products';
}
